export const appRouteConst = {
  dashboard: 'dashboard',
  user: 'user',
  email: 'email',
  pushNotification: 'push-notification',
  auth: 'auth',
  notFound: 'notfound',
  announcement: 'announcement',
  discount: 'discount',
  featureInsight: 'feature-insight',
};